import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { IResponse } from '../shared/models/IResponse.model';
import { ToastService } from './toast.service';
import { IAcType } from '../shared/models/ac-type.model';

@Injectable({
  providedIn: 'root'
})
export class AcTypesService {

  constructor(private httpClient: HttpClient, private toastService: ToastService) { }

  getAcTypes(filter: Partial<IAcType> = { isActive: true }): Observable<IAcType[]> {
    return this.httpClient.post(`${environment.api_base_url}ac-types/search`, filter, {}).pipe(
      map((item: IResponse<IAcType[]>) => {
        if(item?.isError){
          console.log(item.message);
        }
        return item?.data || [];
      }),
      catchError((error) => {
        console.log(error);
        return of([]);
      })
    );
  }

  saveAcType(acType: IAcType): Observable<IAcType> {
    let obs;
    if (acType.id) {
      obs = this.httpClient.patch(`${environment.api_base_url}ac-types/${acType.id}`, acType, {})
    } else {
      obs = this.httpClient.post(`${environment.api_base_url}ac-types/create`, acType, {})
    }
    return obs.pipe(
      map((item: IResponse<IAcType>) => {
        if(item?.isError){
          console.log(item.message);
        }
        return item?.data || {};
      }),
      catchError((error) => {
        this.toastService.showError("Error saving AC Type");
        return of({});
      })
    );
  }

  deleteAcType(acTypeId: number): Observable<any> {
    return this.httpClient.delete(`${environment.api_base_url}ac-types/${acTypeId}`, {}).pipe(
      map((item: IResponse<boolean>) => {
        if(item?.isError){
          console.log(item.message);
        }
        return item?.data || {};
      }),
      catchError((error) => {
        this.toastService.showError("Error deleting curfew time");
        return of({});
      })
    );
  }
}
